import React from "react";
import { BedIcon, DateInput, Field, SearchIcon, SectionHeader, Stepper, TextInput } from "./CreateBlockFields";

const RoomDetails = ({
  roomOwner, setRoomOwner,
  rateCode, setRateCode,
  cutoffDate, setCutoffDate,
  cutoffDays, setCutoffDays,
  printRate, setPrintRate,
  reservationMethod, setReservationMethod,
  openLookup,
}) => (
  <div className="col-md-12">
    <div className="cb-card">
      <SectionHeader icon={<BedIcon />} title="Room Details" />
      <div className="cb-card-body">
        <div className="grid-row">
          <Field label="Room Owner" required className="col-3"><TextInput disabled value={roomOwner} onChange={(event) => setRoomOwner(event.target.value)}  /></Field>
          <Field label="Rate Code" className="col-2"><TextInput inputId="block-rate-code" value={rateCode} onChange={(event) => setRateCode(event.target.value)} icon={<SearchIcon />} onIconClick={() => openLookup("rateCode")} /></Field>
          <Field label="Cutoff Date" className="col-2"><DateInput value={cutoffDate} onChange={setCutoffDate} /></Field>
          <Field label="Cutoff Days" className="col-2 mx-auto"><Stepper value={cutoffDays} onDecrease={() => setCutoffDays((current) => Math.max(0, current - 1))} onIncrease={() => setCutoffDays((current) => current + 1)} /></Field>
          <Field label="Reservation Method" className="col-2"><TextInput placeholder="Select method..." value={reservationMethod} onChange={(event) => setReservationMethod(event.target.value)} icon={<SearchIcon />} onIconClick={() => openLookup("reservationMethod")} /></Field>
          <div className="col-1 checkbox-stack print-rate-field">
            <label className="normal-print-rate">
              <input
                type="checkbox"
                checked={printRate}
                onChange={(event) => setPrintRate(event.target.checked)}
              />
              <span>Print Rate</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RoomDetails;
